import ResultCard from '@component/ResultCard'
import { useTranslation } from 'react-i18next'
import { useOneWaySlab } from './context'

function OneWaySlabResult () {
  const { t } = useTranslation()

  const { form, result } = useOneWaySlab()

  const hidden = !form.formState.isSubmitSuccessful

  return (
    <ResultCard
      title={t('COMPOUND.RESULT', { label: 'GLOSSARY.SLAB' })}
      unit="mm"
      label={t('GLOSSARY.MIN_REQUIRED_THICKNESS')}
      result={result}
      hidden={hidden}
    />
  )
}

export default OneWaySlabResult
